module.exports = __webpack_public_path__ + "static/media/favicon04.f1bbba48.webp";